"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var DataBuilder = /** @class */ (function () {
    function DataBuilder() {
    }
    DataBuilder.buildType = function (data) {
        if (data.Columns) {
            if (data.Columns.length === 0) {
                return [];
            }
        }
        else if (data.columns) { // Temporary fix for 19.09 API bug. With no data in DB, columns and rows comes in lowercase
            if (data.columns.length === 0) {
                return [];
            }
        }
        var numberOfTypes = data.Rows[0].Data.length;
        var types = [];
        var _loop_1 = function (i) {
            var type = {};
            lodash_1.map(data.Columns, function (columnName, index) {
                var row = data.Rows[index];
                var value = row.Data[i];
                switch (row.Name) {
                    case 'name': {
                        var name_1 = { value: value };
                        type.name = name_1;
                        break;
                    }
                    case 'model': {
                        var model = { value: value };
                        type.model = model;
                        break;
                    }
                    case 'typeId': {
                        var id = { value: value.split('@')[0] };
                        type.id = id;
                        var version = { value: value.split('@')[1] };
                        type.version = version;
                        break;
                    }
                    case 'description': {
                        var description = { value: value };
                        type.description = description;
                        break;
                    }
                    case 'tags': {
                        type.tags = value ? value : [];
                        break;
                    }
                }
            });
            types.push(type);
        };
        for (var i = 0; i < numberOfTypes; i++) {
            _loop_1(i);
        }
        return types;
    };
    DataBuilder.buildFunctionType = function (sceFunctionType) {
        var model = sceFunctionType.model, typeId = sceFunctionType.typeId, version = sceFunctionType.version, name = sceFunctionType.name, description = sceFunctionType.description, tags = sceFunctionType.tags, properties = sceFunctionType.properties, isExtensible = sceFunctionType.isExtensible;
        var functionTypeProperties = {
            settings: {
                endpoint: properties.endpoint
            },
            inputs: properties.inputs,
            outputs: properties.outputs
        };
        if (properties.library) {
            functionTypeProperties.library = properties.library;
        }
        var functionType = {
            model: model, typeId: typeId, version: version, name: name, description: description, tags: tags, isExtensible: isExtensible, properties: functionTypeProperties
        };
        return functionType;
    };
    DataBuilder.buildFunctionTypeeWithEncryptionStatus = function (funcType) {
        var _a = funcType.functionType, model = _a.model, typeId = _a.typeId, version = _a.version, name = _a.name, description = _a.description, tags = _a.tags, properties = _a.properties, isExtensible = _a.isExtensible;
        var functionTypeProperties = {
            settings: {
                endpoint: properties.endpoint
            },
            inputs: properties.inputs,
            outputs: properties.outputs
        };
        var functionType = {
            model: model, typeId: typeId, version: version, name: name, description: description, tags: tags, isExtensible: isExtensible, properties: functionTypeProperties
        };
        return {
            functionType: functionType,
            isEncrypted: funcType.isEncrypted
        };
    };
    DataBuilder.buildMultipleFunctionTypeeWithEncryptionStatus = function (data) {
        if (data && data.length > 0) {
            var funcTypeData = data.map(function (funcType, index) {
                var _a = funcType.functionType, model = _a.model, typeId = _a.typeId, version = _a.version, name = _a.name, description = _a.description, tags = _a.tags, properties = _a.properties, isExtensible = _a.isExtensible;
                var functionTypeProperties = {
                    settings: {
                        endpoint: properties.endpoint
                    },
                    inputs: properties.inputs,
                    outputs: properties.outputs
                };
                var functionType = {
                    model: model, typeId: typeId, version: version, name: name, description: description, tags: tags, isExtensible: isExtensible, properties: functionTypeProperties
                };
                return {
                    functionType: functionType,
                    isEncrypted: funcType.isEncrypted
                };
            });
            return funcTypeData;
        }
        else
            return data;
    };
    return DataBuilder;
}());
exports.DataBuilder = DataBuilder;
//# sourceMappingURL=DataBuilder.js.map